var _rect, _rect2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconDatasource = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 3,
  y: 5,
  width: 18,
  height: 4,
  rx: 1,
  fill: "#5757b0"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 3,
  y: 15,
  width: 18,
  height: 4,
  rx: 1,
  fill: "#8080d7"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 11,
  r: 2,
  fill: "#fff"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconDatasource);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_datasource.62ab22669ff73b1d88b3c59e4081a816.svg";